<form [formGroup]="personalInfoForm" [ngClass]="{ submitted: formSubmitted }">
  <div class="layout">
    <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="20px">
      <!-- Avatar Section -->
      <div
        fxLayout="column"
        fxFlex="15"
        fxFlex.lt-lg="100"
        fxLayoutAlign="center center"
        fxLayoutAlign.lt-lg="center start"
        >
        <div class="avatar-wrapper">
          <nz-avatar
            [nzShape]="'circle'"
            [nzSize]="85"
            [nzIcon]="'user'"
            [nzSrc]="avatarImageUrl"
            class="avatar-img"
          ></nz-avatar>

          @if (!trashBtn) {
            <button
              nz-button
              nzType="primary"
            [ngClass]="
              isEditMode
                ? 'upload-patient-picture-btn avatar-button-bottom-right'
                : 'upload-patient-picture-btn-disabled avatar-button-bottom-right'
            "
              [disabled]="!isEditMode"
              (click)="uploadAndOpenImageCropper()"
              >
              <i nz-icon nzType="icons:uploadProfile" style="font-size: 12px"></i>
            </button>
          }

          @if (trashBtn) {
            <button
              nz-button
              nzType="primary"
            [ngClass]="
              isEditMode
                ? 'remove-patient-picture-btn avatar-button-bottom-right'
                : 'remove-patient-picture-btn-disabled avatar-button-bottom-right'
            "
              [disabled]="!isEditMode"
              (click)="removeProfilePicture()"
              >
              <i nz-icon nzType="icons:deleteProfile" style="font-size: 12px"></i>
            </button>
          }
        </div>
      </div>

      <!-- Personal Info Section -->
      <div fxLayout="column" fxFlex="85" fxFlex.lt-lg="100" fxLayoutGap="20px">
        <!-- First Row: First Name, Last Name, Email, Phone -->
        <div fxLayout="row wrap" fxLayoutGap="20px" class="row-wrap">
          @for (
            field of [
            { label: 'First name', control: 'firstName', type: 'text' },
            { label: 'Last name', control: 'lastName', type: 'text' },
            { label: 'Email address', control: 'email', type: 'email' },
            { label: 'Phone number', control: 'phone', type: 'tel' }
            ]
            ; track
            field) {
            <div
              fxLayout="column"
              fxFlex="21"
              fxFlex.lt-lg="41"
              class="add-patient-col"
              >
              <label
                >{{ field.label | translate
                }}@if (field.label === 'Phone number') {
                <span
                  class="optional"
                  >{{ "(optional)" | translate }}</span
                  >
                  }</label
                  >
                  @switch (field.type) {
                    @case ('text') {
                      <input
                        class="add-patient-input"
                        [type]="field.type"
                        formControlName="{{ field.control }}"
                        [maxLength]="51"
                        />
                    }
                    @case ('email') {
                      <input
                        class="add-patient-input"
                        type="email"
                        formControlName="{{ field.control }}"
                        />
                    }
                    @case ('tel') {
                      <ngx-intl-tel-input
                        [cssClass]="'custom'"
                        [preferredCountries]="[CountryISO.Cyprus, CountryISO.Greece]"
                        [enableAutoCountrySelect]="true"
                        [enablePlaceholder]="false"
                        [searchCountryFlag]="true"
                  [searchCountryField]="[
                    SearchCountryField.Iso2,
                    SearchCountryField.Name
                  ]"
                        [selectFirstCountry]="false"
                        [maxLength]="50"
                        [phoneValidation]="true"
                        [separateDialCode]="false"
                        name="phone"
                        formControlName="phone"
                        >
                      </ngx-intl-tel-input>
                    }
                  }
                </div>
              }
            </div>

            <!-- Second Row: Gender, Date of Birth, Place, District -->
            <div fxLayout="row wrap" fxLayoutGap="20px" class="row-wrap">
              @for (
                field of [
                {
                label: 'Gender',
                control: 'genderId',
                type: 'select',
                options: gendersList
                },
                {
                label: 'Date of birth',
                control: 'dateOfBirth',
                type: 'date'
                },
                {
                label: 'Place of Birth',
                control: 'placeOfBirthId',
                type: 'select',
                options: placeOfBirthList,
                optional: true
                },
                {
                label: 'District of Birth',
                control: 'districtOfBirth',
                type: 'conditional',
                optional: true
              }
              ]
              ; track
              field) {
              <div
                fxLayout="column"
                fxFlex="21"
                fxFlex.lt-lg="41"
                class="add-patient-col"
                >
                <label
                  >{{ field.label | translate
                  }}@if (field.optional) {
                  <span class="optional">{{
                    "(optional)" | translate
                  }}</span>
                  }</label
                  >
                  @switch (field.type) {
                    @case ('select') {
                      <nz-select
                        class="add-patient-inputZorro"
                        nzShowSearch
                        nzAllowClear
                        formControlName="{{ field.control }}"
                        >
                        @for (opt of field.options; track opt) {
                          <nz-option
                            [nzLabel]="opt.name"
                            [nzValue]="opt.id"
                          ></nz-option>
                        }
                      </nz-select>
                    }
                    @case ('date') {
                      <input
                        type="date"
                        class="add-patient-input"
                        formControlName="{{ field.control }}"
                        [min]="get1900Date()"
                        [max]="getCurrentDate()"
                        />
                    }
                    @case ('conditional') {
                      @if (!isPlaceOfBirthCyprus) {
                        <input
                          class="add-patient-input"
                          [placeholder]="'District of Birth' | translate"
                          formControlName="{{ field.control }}"
                          [maxLength]="51"
                          />
                        } @else {
                          <nz-select
                            class="add-patient-inputZorro"
                            nzShowSearch
                            nzAllowClear
                            [nzPlaceHolder]="'Select a District' | translate"
                            formControlName="{{ field.control }}"
                            >
                            @for (city of cyprusCities; track city) {
                              <nz-option
                                [nzLabel]="city | translate"
                                [nzValue]="city"
                              ></nz-option>
                            }
                          </nz-select>
                        }
                      }
                    }
                  </div>
                }
              </div>

              <!-- Documents -->
              <div class="title">
                {{
                documentDto.controls.length > 1
                ? "Identifiers"
                : ("Identifier" | translate)
                }}
              </div>
              @for (doc of documentDto.controls; track doc; let i = $index) {
                <div
                  formArrayName="documentDto"
                  >
                  <div
                    [formGroupName]="i"
                    fxLayout="row wrap"
                    fxLayoutGap="20px"
                    class="row-wrap"
                    >
                    <div
                      fxLayout="column"
                      fxFlex="21"
                      fxFlex.lt-lg="41"
                      class="add-patient-col"
                      >
                      <label>{{ "Document Type" | translate }}</label>
                      <nz-select
                        class="add-patient-inputZorro"
                        nzShowSearch
                        nzAllowClear
                        formControlName="documentTypeId"
                        >
                        @for (d of documentTypeList; track d) {
                          <nz-option
                            [nzLabel]="d.name"
                            [nzValue]="d.id"
                          ></nz-option>
                        }
                      </nz-select>
                    </div>
                    <div
                      fxLayout="column"
                      fxFlex="21"
                      fxFlex.lt-lg="41"
                      class="add-patient-col"
                      >
                      <label>{{ "Document Number" | translate }}</label>
                      <input
                        class="add-patient-input"
                        formControlName="documentNumber"
                        [maxLength]="50"
                        />
                      </div>
                      @if (doc.get('documentTypeId')?.value !== 3) {
                        <div
                          fxLayout="column"
                          fxFlex="21"
                          fxFlex.lt-lg="41"
                          class="add-patient-col"
                          >
                          <label>{{ "Issuing Country" | translate }}</label>
                          <nz-select
                            class="add-patient-inputZorro"
                            nzShowSearch
                            nzAllowClear
                            formControlName="documentCountryIssuedId"
                            >
                            @for (country of countriesList; track country) {
                              <nz-option
                                [nzLabel]="country.name"
                                [nzValue]="country.id"
                              ></nz-option>
                            }
                          </nz-select>
                        </div>
                      }
                    </div>
                  </div>
                }

                <!-- Additional Info, Family, Education, Income, Religion -->
                <!-- Use the same vertical label + input pattern for all remaining rows -->
                <!-- Example for Registration Agent and Date of Admission -->
                <div fxLayout="row wrap" fxLayoutGap="20px" class="row-wrap">
                  <div
                    fxLayout="column"
                    fxFlex="21"
                    fxFlex.lt-lg="41"
                    class="add-patient-col"
                    >
                    <label>{{ "Registration Agent" | translate }}</label>
                    <input
                      type="text"
                      class="add-patient-input"
                      formControlName="registrationAgentFullName"
                      [maxLength]="50"
                      />
                    </div>
                    <div
                      fxLayout="column"
                      fxFlex="21"
                      fxFlex.lt-lg="41"
                      class="add-patient-col"
                      >
                      <label
                        >{{ "Date of Admission" | translate
                        }}<span class="optional">{{
                        "(optional)" | translate
                      }}</span></label
                      >
                      <input
                        type="date"
                        class="add-patient-input"
                        formControlName="dateOfAdmission"
                        />
                      </div>
                    </div>

                    <!-- Repeat the same structure for Family Status, Closest Relatives, Education, Occupation -->
                    <div fxLayout="row wrap" fxLayoutGap="20px" class="row-wrap">
                      <div
                        fxLayout="column"
                        fxFlex="21"
                        fxFlex.lt-lg="41"
                        class="add-patient-col"
                        >
                        <label
                          >{{ "Family Status" | translate
                          }}<span class="optional">{{
                          "(optional)" | translate
                        }}</span></label
                        >
                        <nz-select
                          class="add-patient-inputZorro"
                          nzShowSearch
                          nzAllowClear
                          formControlName="familyStatusId"
                          >
                          @for (status of familyStatusList; track status) {
                            <nz-option
                              [nzLabel]="status.name"
                              [nzValue]="status.id"
                            ></nz-option>
                          }
                        </nz-select>
                        @if (personalInfoForm.get('familyStatusId')?.value == 6) {
                          <input
                            class="add-patient-input"
                            formControlName="familyStatusOther"
                            placeholder="{{ 'Please specify' | translate }}"
                            [maxLength]="50"
                            />
                        }
                      </div>
                      <div
                        fxLayout="column"
                        fxFlex="21"
                        fxFlex.lt-lg="41"
                        class="add-patient-col"
                        >
                        <label
                          >{{ "Closest Relatives" | translate
                          }}<span class="optional">{{
                          "(optional)" | translate
                        }}</span></label
                        >
                        <nz-select
                          class="add-patient-inputZorro"
                          nzShowSearch
                          nzAllowClear
                          formControlName="closestRelativesId"
                          >
                          @for (relative of closestRelativesList; track relative) {
                            <nz-option
                              [nzLabel]="relative.name"
                              [nzValue]="relative.id"
                            ></nz-option>
                          }
                        </nz-select>
                        @if (personalInfoForm.get('closestRelativesId')?.value == 7) {
                          <input
                            class="add-patient-input"
                            formControlName="closestRelativesOther"
                            placeholder="{{ 'Please specify' | translate }}"
                            [maxLength]="50"
                            />
                        }
                      </div>
                      <div
                        fxLayout="column"
                        fxFlex="21"
                        fxFlex.lt-lg="41"
                        class="add-patient-col"
                        >
                        <label
                          >{{ "Education Level" | translate
                          }}<span class="optional">{{
                          "(optional)" | translate
                        }}</span></label
                        >
                        <nz-select
                          class="add-patient-inputZorro"
                          nzShowSearch
                          nzAllowClear
                          formControlName="educationLevelId"
                          >
                          @for (education of educationLevelList; track education) {
                            <nz-option
                              [nzLabel]="education.name"
                              [nzValue]="education.id"
                            ></nz-option>
                          }
                        </nz-select>
                        @if (personalInfoForm.get('educationLevelId')?.value == 5) {
                          <input
                            class="add-patient-input"
                            formControlName="educationLevelOther"
                            placeholder="{{ 'Please specify' | translate }}"
                            [maxLength]="50"
                            />
                        }
                      </div>
                      <div
                        fxLayout="column"
                        fxFlex="21"
                        fxFlex.lt-lg="41"
                        class="add-patient-col"
                        >
                        <label
                          >{{ "Occupation" | translate
                          }}<span class="optional">{{
                          "(optional)" | translate
                        }}</span></label
                        >
                        <input
                          class="add-patient-input"
                          formControlName="occupation"
                          [maxLength]="100"
                          />
                        </div>
                      </div>

                      <!-- Income, Source, Religion (same pattern) -->
                      <div fxLayout="row wrap" fxLayoutGap="20px" class="row-wrap">
                        <div
                          fxLayout="column"
                          fxFlex="21"
                          fxFlex.lt-lg="41"
                          class="add-patient-col"
                          >
                          <label
                            >{{ "Amount of Income" | translate
                            }}<span class="optional">{{
                            "(optional)" | translate
                          }}</span></label
                          >
                          <input class="add-patient-input" formControlName="amountOfIncome" />
                        </div>
                        <div
                          fxLayout="column"
                          fxFlex="21"
                          fxFlex.lt-lg="41"
                          class="add-patient-col"
                          >
                          <label
                            >{{ "Source of Income" | translate
                            }}<span class="optional">{{
                            "(optional)" | translate
                          }}</span></label
                          >
                          <nz-select
                            class="add-patient-inputZorro"
                            nzShowSearch
                            nzAllowClear
                            formControlName="sourceOfIncomeId"
                            >
                            @for (source of sourceOfIncomeList; track source) {
                              <nz-option
                                [nzLabel]="source.name"
                                [nzValue]="source.id"
                              ></nz-option>
                            }
                          </nz-select>
                        </div>
                        <div
                          fxLayout="column"
                          fxFlex="21"
                          fxFlex.lt-lg="41"
                          class="add-patient-col"
                          >
                          <label
                            >{{ "Religion" | translate
                            }}<span class="optional">{{
                            "(optional)" | translate
                          }}</span></label
                          >
                          <nz-select
                            class="add-patient-inputZorro"
                            nzShowSearch
                            nzAllowClear
                            formControlName="religionId"
                            >
                            @for (religion of religionList; track religion) {
                              <nz-option
                                [nzLabel]="religion.name"
                                [nzValue]="religion.id"
                              ></nz-option>
                            }
                          </nz-select>
                          @if (personalInfoForm.get('religionId')?.value == 26) {
                            <input
                              class="add-patient-input"
                              formControlName="religionOther"
                              placeholder="{{ 'Please specify' | translate }}"
                              [maxLength]="50"
                              />
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
